import api from './api';
import {
  SalesLeaderboardParams,
  SalesLeaderboardResponse,
  AreaLeaderboardParams,
  AreaLeaderboardResponse,
} from '../types/leaderboard';

/**
 * Fetches the sales performance leaderboard with top 3 podium and complete ranked list.
 * STRICT COMPLIANCE: No leading slash on relative Axios route.
 */
export const getSalesLeaderboard = async (params: SalesLeaderboardParams): Promise<SalesLeaderboardResponse> => {
  const response = await api.get<SalesLeaderboardResponse>('dashboard/leaderboard/sales', {
    params,
  });
  return response.data;
};

/**
 * Fetches the property area performance leaderboard with top 3 podium and complete ranked list.
 * STRICT COMPLIANCE: No leading slash on relative Axios route.
 */
export const getAreaLeaderboard = async (params: AreaLeaderboardParams): Promise<AreaLeaderboardResponse> => {
  const response = await api.get<AreaLeaderboardResponse>('dashboard/leaderboard/areas', {
    params,
  });
  return response.data;
};
